import { useEffect, useState } from 'react';
import { useGetCounterparties } from 'api/counterparties';
import { AutocompletePaginationAsync } from 'components/Inputs';
import { Counterparty } from 'pages/invoices/invoices.types';
import { ControllerRenderProps } from 'react-hook-form';
import { createHandleOnBlur, handleChange } from 'utils/form.utils';

export type CounterpartyOption = {
  id: number;
  code: string;
};

type Props = {
  field: Pick<ControllerRenderProps, 'value' | 'onChange' | 'onBlur' | 'ref'>;
  error?: boolean;
};

export const CounterpartySelect = ({ field, error }: Props) => {
  const [options, setOptions] = useState<Counterparty[]>([]);
  const [params, setParams] = useState({
    filterText: '',
    pageNumber: 1,
    resultSize: 25,
  });

  const { getCounterparties, loading, counterpartiesData } =
    useGetCounterparties();

  useEffect(() => {
    getCounterparties(params);
  }, [getCounterparties, params]);

  useEffect(() => {
    if (counterpartiesData?.length) {
      setOptions((prev) => [
        ...prev,
        ...counterpartiesData.filter((counterparty) => counterparty.enabled),
      ]);
    }
  }, [counterpartiesData]);

  return (
    <AutocompletePaginationAsync
      value={field.value ?? null}
      options={options}
      loading={loading}
      error={error}
      padding='dense'
      width={280}
      getOptionLabel={(option) => (option as Counterparty).code}
      isOptionEqualToValue={(option, value) =>
        (option as Counterparty).id === (value as Counterparty).id
      }
      onChange={(_, value) => field.onChange(value)}
      onBlur={createHandleOnBlur(setOptions, setParams, field.onBlur)}
      handleSearchChange={handleChange(setOptions, setParams)}
      onScrollBottom={() =>
        setParams((prev) => ({ ...prev, pageNumber: prev.pageNumber + 1 }))
      }
    />
  );
};
